import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from 'react';
import { Button, Typography, useOverlayContext } from 'seagull';
import { createEmptyServiceItem } from '~/components/BillClientModal/BillClientItem.utils';
import BillClientModal from '~/components/BillClientModal/BillClientModal';
import { useStore } from '~/contexts';
import { useQboTimeActivities } from '~/hooks/reactQuery/queries/useQboTimeActivities';
import { Intent } from '~/infra/access-control';
import { billableStateModel, serviceBillingModel } from '~/models';
import { isSuitableForTimeActivities } from '~/models/service/selectors';
import { selectors } from '~/store/state-selectors';
import { nonBillableReasonToTooltip } from '../BillingControl.utils';
import styles from '../ServicesSection.module.scss';
import ServiceTitle from './ServiceTitle';
import UnbilledTimeActivities from './UnbilledTimeActivities';
export default function ManualServiceBillingItem(props) {
    const { name, costDisplay, unitCapDisplay, service, idx, agreement, invoiceDateInfo, earliestBillableDate, controlData, qboItemName, xeroItemName, qboClassName } = props;
    const overlayContext = useOverlayContext();
    const { manualServices, totalCredits } = controlData;
    const maxCharges = serviceBillingModel.maxCharges(service.billing);
    const { data: timeActivities } = useQboTimeActivities(agreement.id);
    const allowTimeActivities = useStore(selectors.integration.allowTimeActivities);
    const nonBillableReason = useMemo(()=>{
        const manualServiceBilling = manualServices[service.id];
        return (manualServiceBilling === null || manualServiceBilling === void 0 ? void 0 : manualServiceBilling.billableState) ? billableStateModel.nonBillableReason(manualServiceBilling.billableState) : null;
    }, [
        manualServices,
        service.id
    ]);
    const serviceTimeActivitiesLength = (timeActivities === null || timeActivities === void 0 ? void 0 : timeActivities.getTimeActivitiesForService(service.id).length) || 0;
    return /*#__PURE__*/ _jsxs("li", {
        "data-testid": "service-".concat(idx),
        className: styles.serviceBox,
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: styles.serviceDescription,
                children: [
                    /*#__PURE__*/ _jsx(ServiceTitle, {
                        name: name,
                        serviceId: service.id,
                        qboItemName: qboItemName,
                        xeroItemName: xeroItemName,
                        qboClassName: qboClassName
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: styles.cost,
                        children: [
                            /*#__PURE__*/ _jsx(Typography, {
                                testId: "cost",
                                variant: "paragraph2",
                                skin: "secondary",
                                children: costDisplay
                            }),
                            unitCapDisplay && /*#__PURE__*/ _jsx(Typography, {
                                testId: "unit-cap",
                                variant: "paragraph2",
                                skin: "secondary",
                                children: unitCapDisplay
                            })
                        ]
                    }),
                    (maxCharges === null || maxCharges === void 0 ? void 0 : maxCharges.enabled) && maxCharges.limit && /*#__PURE__*/ _jsx("div", {
                        children: /*#__PURE__*/ _jsxs(Typography, {
                            testId: "max-charges-added-indicator",
                            variant: "paragraph2",
                            skin: "secondary",
                            children: [
                                maxCharges.limit - (maxCharges.chargesLeft || 0),
                                "/",
                                maxCharges.limit,
                                " times added"
                            ]
                        })
                    }),
                    allowTimeActivities && !!serviceTimeActivitiesLength && isSuitableForTimeActivities(service) && /*#__PURE__*/ _jsx(UnbilledTimeActivities, {
                        serviceTimeActivitiesLength: serviceTimeActivitiesLength
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("div", {
                className: styles.lineItemAction,
                children: /*#__PURE__*/ _jsx(Button, {
                    size: "small",
                    intent: Intent.Bill,
                    testId: "billing-control-manual-bill-".concat(service === null || service === void 0 ? void 0 : service.id),
                    bi: {
                        name: 'bill_service',
                        data: {
                            serviceId: service === null || service === void 0 ? void 0 : service.id
                        }
                    },
                    "data-reason": nonBillableReason || '',
                    disabled: nonBillableReason != null,
                    tooltip: nonBillableReason != null ? {
                        placement: 'top',
                        title: nonBillableReasonToTooltip[nonBillableReason]
                    } : undefined,
                    onClick: ()=>{
                        overlayContext.showModal({
                            biName: 'bill_client_modal',
                            closeOnClickOutside: true,
                            closeOnEscapeKey: true,
                            content: (param)=>{
                                let { dismissModal } = param;
                                return /*#__PURE__*/ _jsx(BillClientModal, {
                                    dismissModal: dismissModal,
                                    defaultItem: createEmptyServiceItem(service),
                                    manualServicesBilling: manualServices,
                                    invoiceDateInfo: invoiceDateInfo,
                                    relationshipId: agreement.id,
                                    totalCredits: totalCredits,
                                    earliestBillableDate: earliestBillableDate,
                                    controlData: controlData
                                });
                            }
                        });
                    },
                    children: "Bill"
                })
            })
        ]
    });
}
